import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";

function stripContent(content = "") {
  return content
    .replace(/<[^>]*>/g, " ")
    .replace(/[#*_`>\-[\]()]/g, " ")
    .replace(/\s+/g, " ")
    .trim();
}

function getExcerpt(post) {
  const text = stripContent(post.content);
  return text.length > 180 ? `${text.slice(0, 180).trim()}...` : text;
}

export function PostList() {
  const [posts, setPosts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchPosts = async () => {
      try {
        const response = await fetch("/posts.json");
        if (!response.ok) {
          throw new Error(`HTTP error! Status: ${response.status}`);
        }
        const data = await response.json();
        setPosts(data);
      } catch (err) {
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };

    fetchPosts();
  }, []);

  if (loading) {
    return (
      <div className="editorial-state">
        <div className="editorial-state__inner">
          <p className="editorial-state__message">Loading writing...</p>
        </div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="editorial-state">
        <div className="editorial-state__inner">
          <p className="editorial-state__message">Error: {error}</p>
        </div>
      </div>
    );
  }

  return (
    <section className="publication" aria-labelledby="writing-heading">
      <div className="publication__inner">
        <header className="publication__header">
          <div>
            <p className="publication-kicker">Notes and essays</p>
            <h1 id="writing-heading">My Writing</h1>
          </div>
          <p>
            Here's a working archive of programming essays, book notes, and
            technical reflections over the last few years of programming. I'm
            pretty open to feedback so if you read something and want to share
            your thoughts feel free to reach out!
          </p>
        </header>

        <ol className="post-list">
          {posts.map((post) => (
            <li key={post.id} className="post-list__item">
              <Link
                to={`/blog/${post.id}`}
                className="post-list__title"
              >
                {post.title}
              </Link>
              <p className="post-list__excerpt">{getExcerpt(post)}</p>
            </li>
          ))}
        </ol>
      </div>
    </section>
  );
}
